import { useSelector } from 'react-redux'
import { selectDomainRevision } from '@/features/domain'

export function useDomainDataChanged() {
  const domainRevision = useSelector(selectDomainRevision)

  return domainRevision
}
